import { render, staticRenderFns } from "./TabsHeader.vue?vue&type=template&id=7b0312d3&scoped=true&"
import script from "./TabsHeader.vue?vue&type=script&lang=js&"
export * from "./TabsHeader.vue?vue&type=script&lang=js&"
import style0 from "./TabsHeader.vue?vue&type=style&index=0&id=7b0312d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0312d3",
  null
  
)

export default component.exports